import { createApi } from '@core/fetch'

/**
 * 四大团队设置
 */
export default {
  groupMemberList: createApi(
    '/hps/home/localServerMerchant/fourRole/groupMemberList'
  ),
  deleteMember: createApi.post(
    '/hps/mainAdmin/localServerMerchant/fourRole/delete'
  ),
  // 邀请成员（团队）
  inviteMember: createApi.post(
    '/hps/mainAdmin/localServerMerchant/fourRole/invite'
  ),
  // 成员列表（团队）
  memberList: createApi('/hps/mainAdmin/localServerMerchant/fourRole/list'),
  setMemberShow: createApi.post(
    '/hps/mainAdmin/localServerMerchant/fourRole/setMemberShow'
  )
}
